import { goToRouteBySearch } from '@/components/common/EnquiriesScreen/utils/goToRouteBySearch';

function useProductsNavigation() {
  const goToProductsBySearch = (searchText?: string) => {
    goToRouteBySearch(searchText);
  };

  return { goToProductsBySearch };
}

export default useProductsNavigation;
